export enum EClientProduct {
    DIGITAL_ASSETS = 'digital-assets',
    DELIVERABLE_FX = 'deliverable-fx',
    NON_DELIVERABLE_FORWARDS = 'non-deliverable-forwards',
    PRECIOUS_METALS = 'precious-metals',
    EQUITY_INDEX_SWAPS = 'equity-index-swaps',
    FCM = 'fcm',
    ROUTE28 = 'route28',
    FIXED_INCOME = 'fixed-income',
    DELTA_ONE = 'delta-one',
    MFL = 'mfl',
    SECURITIES_LENDING = 'securities-lending',
}
